import React, {useEffect, useState} from 'react'
import s from "./cybershore_game.module.css"

import UnityIFrame, {IFrame, Rectum} from "../../components/unityIFrame";
import {IFrames} from "../../AssetReferences";

const PRE_WAIT_TIME = 5000; // time before opacity transition starts (avoids unity logo displaying)

export default function CybershoreGame({displayCover}) {
    const [opacity, setOpacity] = useState(0)
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        if (!isRunning) {
            setTimeout(() => {
                setIsRunning(true);
                setOpacity(100)
            }, PRE_WAIT_TIME)
        }
        return () => setOpacity(0)
    }, []);

    return (
        <>
            <div id={"CybershoreContainer"} className={s.CybershoreContainer}
                 style={{opacity: opacity + "%"}}>

                <UnityIFrame
                    id={"Cybershore_iFrame"}
                    iFrame_src={IFrames.CybershoreMeditations}
                    rectum={new Rectum(0, -5, 100, 110) // fills, though trims top and bottom slightly
                        // rectum={new Rectum(0, 10, 100, 80) // "widescreen vibe"
                    }/>

            </div>
        </>)
}

